import { FieldNames } from 'app/models/fields/names';
import { Section } from 'app/models/types';
import { LOAN_OFFICER_INFO } from './constants';
import { LOAN_OFFICER_QUESTIONS } from '../questions/loan-officer';
import { handleLoanOfficerRedirect } from '../../actions/form/transfer';

export const getLoanOfficerSectionById = (id: number): Section => {
  return LOAN_OFFICER_SECTIONS.find((section) => section.id === id) as Section;
};

const LOAN_OFFICER_SECTIONS: Section[] = [
  {
    id             : LOAN_OFFICER_INFO,
    questions      : LOAN_OFFICER_QUESTIONS.getByName([
      FieldNames.brokerLoanOfficerFirstName,
      FieldNames.brokerLoanOfficerLastName,
      FieldNames.brokerLoanOfficerEmail,
      FieldNames.brokerLoanOfficerPhone,
      FieldNames.brokerLoanOfficerCompanyNMLS,
    ]),
    title : 'Enter your Loan Officer information',
    hideBackButton : true,
    hideProgressBar: true,
    submitAction : handleLoanOfficerRedirect,
    submitText : 'Next',
  },
];
